/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Link from 'next/link'

import Header from '../Header'
import styles from './BlockStreamer.module.scss'

const BlockStreamer = ({dataBlock}: any) => {
  console.log('dataBlock', dataBlock)
  return (
    <div>
      <Header />
      <div className={styles.blockStreamerWrapper}>
        <img
          src="/images/mascot-37.png"
          alt="img-block"
          style={{
            marginBottom: '20px',
          }}
        />
        <h1>Streamer này hiện đang bị khóa</h1>
        <p>Streamer đang trong thời gian bị khóa do vi phạm.</p>
        <div className={styles.blockStreamerInfo}>
          <div className={styles.blockStreamerInfoDateRegist}>
            <span>Ngày khóa: </span>
            <span className="font-bold">
              {dataBlock?.response.data.black?.regist_date
                ? new Date(
                    dataBlock.response.data.black.regist_date,
                  ).toLocaleString('vi-VN', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })
                : ''}
            </span>
          </div>
          <div className={styles.blockStreamerInfoDateExpire}>
            <span>Ngày mở khóa: </span>
            <span className="font-bold">
              {dataBlock?.response.data.black?.expire_date}
            </span>
          </div>
          <div className={styles.blockStreamerInfoTerm}>
            <span>Thời gian khóa: </span>
            <span className="font-bold">
              {dataBlock?.response.data.black?.regist_term} ngày
            </span>
          </div>
          <div className={styles.blockStreamerInfoReason}>
            <span>Lý do: </span>
            <span className="font-bold">
              {dataBlock?.response.data.black?.reason}
            </span>
          </div>
        </div>
        <div className={styles.blockStreamerInfoButton}>
          <Link href={`${process.env.NEXT_PUBLIC_ONLIVE}`}>
            <button>Trở về trang chủ</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BlockStreamer
